import { generateMutations } from '@homeservices/tool-kit/utils/store';
import { verifyRecaptchaResponse } from '@homeservices/api-kit/workorder/riskassessment/v4';

function initialState () {
  return {
    verifyRecaptchaResponse: {},
    recaptchaToken: null,
    recaptchaTokens: {}, // for reuse logic
    isRecaptchaAvailable: false,
    userInteractionId: null,
    isRecaptchaLoading: false,
  };
}

export default function () {
  return {
    namespaced: true,
    state: initialState(),
    getters: {
      isRecaptchaAvailable (state) {
        return state.isRecaptchaAvailable;
      },
      userInteractionId (state) {
        return state.userInteractionId;
      },
      getRiskResult (state) {
        const response = state.verifyRecaptchaResponse || {};
        const calendar = response.calendar || {};
        const lead = response.lead || {};
        return calendar.action || lead.action;
      },
      getOverallRiskResult (state) {
        const response = state.verifyRecaptchaResponse || {};
        const calendar = response.calendar || {};
        const lead = response.lead || {};
        return calendar.res || lead.res;
      },
    },
    actions: {
      async fetchRecaptchaToken ({ commit }, userAction) {
        const siteKey = window.__SERVER_CTX__.globals.RECAPTCHA_KEY;
        return new Promise((resolve, reject) => {
          window.grecaptcha.ready(() => {
            window.grecaptcha
              .execute(siteKey, { action: userAction })
              .then((token) => {
                commit('updateRecaptchaToken', token);
                resolve(token);
              })
              .catch((err) => {
                commit('updateRecaptchaToken', null);
                reject(err);
              });
          });
        });
      },

      async getRecaptchaScore ({ dispatch, commit, rootState, getters },
        { action, recaptchaSysId, recaptchaToken }) {
        try {
          let token = recaptchaToken;
          if (!token) {
            token = await dispatch('fetchRecaptchaToken', action);
          }
          if (!token) {
            throw new Error('No recaptcha token received');
          }

          const { userInteractionId: currentUserInteractionId } = getters;
          let userInteractionId = currentUserInteractionId;
          if (!userInteractionId) {
            userInteractionId = `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
            commit('updateUserInteractionId', userInteractionId);
          }

          const jobrequestState = rootState.jobrequest || {};
          const overviewState = jobrequestState.overview || {};
          const locationState = jobrequestState.location || {};
          const serviceState = jobrequestState.service || {};
          const serviceId = serviceState.service_identifier || '';
          const appName = 'proreferral';
          const spFlow = 'the_home_depot_proreferral';
          const remoteIp = (window.__SERVER_CTX__
            && window.__SERVER_CTX__.globals
            && window.__SERVER_CTX__.globals.REMOTE_IP) || '';

          const params = {
            uid: userInteractionId,
            app_name: appName,
            rc: {
              rc_response: token,
              remote_ip: remoteIp,
              rc_id: recaptchaSysId || '',
            },
            action,
            service_identifier: serviceId,
            sp_flow: spFlow,
            first_name: overviewState.firstName || '',
            last_name: overviewState.lastName || '',
            email: overviewState.email || '',
            phone: overviewState.phone || '',
            address_line1: '',
            address_line2: '',
            city: locationState.city || '',
            state: locationState.state || '',
            zipcode: locationState.zipcode || '',
          };

          const { data } = await verifyRecaptchaResponse(params);
          // Store latest response
          commit('updateVerifyRecaptchaResponseByAction', { action, response: data });
          commit('updateRecaptchaTokenByAction', { action, token });
          commit('updateIsRecaptchaAvailable', true);
        } catch (err) {
          commit('updateIsRecaptchaAvailable', false);
          throw new Error(`Error verifying recaptcha token: ${err.message}`);
        }
      },
    },
    mutations: {
      ...generateMutations([
        'recaptchaToken',
        'userInteractionId',
        'isRecaptchaAvailable',
        'verifyRecaptchaResponse',
        'isRecaptchaLoading',
      ]),
      updateVerifyRecaptchaResponseByAction (state, { action, response }) {
        if (!state.verifyRecaptchaResponse) state.verifyRecaptchaResponse = {};
        state.verifyRecaptchaResponse[action] = response;
      },
      updateRecaptchaTokenByAction (state, { action, token }) {
        if (!state.recaptchaTokens) state.recaptchaTokens = {};
        state.recaptchaTokens[action] = token;
      },
      resetRecaptcha (state) {
        Object.assign(state, initialState());
      },
    },
  };
}
